<div class="ipaddress-origin-container">
  <!-- Header Section -->
  <div class="header-section">
    <h3 class="section-title">IP Address Origin Management</h3>
    <p class="section-description">
      Manage IP address validation and allowed origins for this application
    </p>
  </div>

  <!-- IP Address Validation Toggle -->
  <div class="validation-toggle-section">
    <div class="toggle-container">
      <mat-slide-toggle
        [checked]="application.validateIPAddressOrigin"
        (change)="toggleIPAddressValidation()"
        [disabled]="isLoading"
        color="primary"
        class="validation-toggle"
      >
        <span class="toggle-label">Validate IP Address Origin</span>
      </mat-slide-toggle>
      <div class="toggle-description">
        When enabled, only requests from specified IP addresses will be allowed
      </div>
    </div>
    @if (isLoading) {
      <mat-spinner diameter="20" class="loading-spinner"></mat-spinner>
    }
  </div>

  <!-- Messages Section -->
  @if (errorMessage || successMessage) {
    <div class="messages-section">
      @if (errorMessage) {
        <mat-error class="error-message">
          <mat-icon>error</mat-icon>
          {{ errorMessage }}
          <button
            mat-icon-button
            (click)="clearMessages()"
            class="close-button"
          >
            <mat-icon>close</mat-icon>
          </button>
        </mat-error>
      }

      @if (successMessage) {
        <div class="success-message">
          <mat-icon>check_circle</mat-icon>
          {{ successMessage }}
          <button
            mat-icon-button
            (click)="clearMessages()"
            class="close-button"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
      }
    </div>
  }

  <!-- Add IP Address Section -->
  <div class="add-ip-section">
    <h4 class="subsection-title">Add New IP Address</h4>
    <form
      [formGroup]="ipAddressForm"
      (ngSubmit)="addIPAddress()"
      class="ip-form"
    >
      <div class="form-row">
        <mat-form-field appearance="outline" class="ip-input">
          <mat-label>IP Address</mat-label>
          <input
            matInput
            formControlName="ipAddress"
            placeholder="192.168.1.1"
          />
          @if (ipAddressForm.get('ipAddress')!.hasError('required')) {
            <mat-error> IP address is required </mat-error>
          }
          @if (ipAddressForm.get('ipAddress')!.hasError('pattern')) {
            <mat-error>
              Please enter a valid IP address (e.g., 192.168.1.1)
            </mat-error>
          }
        </mat-form-field>

        <button
          mat-raised-button
          color="primary"
          type="submit"
          [disabled]="ipAddressForm.invalid || isAdding"
          class="add-button"
        >
          @if (!isAdding) {
            <mat-icon>add</mat-icon>
          }
          @if (isAdding) {
            <mat-spinner diameter="16"></mat-spinner>
          }
          Add IP Address
        </button>
      </div>
    </form>
  </div>

  <!-- IP Addresses List Section -->
  <div class="ip-list-section">
    <h4 class="subsection-title">
      Allowed IP Addresses
      @if (hasIPAddresses) {
        <span class="ip-count">({{ ipAddresses.length }})</span>
      }
    </h4>

    @if (hasIPAddresses) {
      <div class="ip-list-container">
        @for (
          ipAddress of ipAddresses;
          track trackByIpAddress($index, ipAddress)
        ) {
          <div class="ip-item">
            <div class="ip-info">
              <mat-icon class="ip-icon">computer</mat-icon>
              <span class="ip-text">{{ ipAddress }}</span>
            </div>
            <button
              mat-icon-button
              color="warn"
              (click)="removeIPAddress(ipAddress)"
              [disabled]="isLoading"
              class="remove-button"
              matTooltip="Remove IP Address"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        }
      </div>
    } @else {
      <div class="no-ip-message">
        <mat-icon class="no-ip-icon">info</mat-icon>
        <p>
          No IP addresses configured. Add IP addresses above to restrict access
          to specific origins.
        </p>
      </div>
    }
  </div>
</div>
